import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Button, Modal } from 'react-bootstrap';

const MessageTemplateDeleteModal = ({
  showModal,
  handleClose,
  handleConfirm,
  template
}) => {
  return (
    <Modal show={showModal} onHide={handleClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          <FontAwesomeIcon icon={faExclamationTriangle} className="me-2 text-warning" />
          Confirmar Exclusão
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Tem certeza que deseja excluir o modelo de mensagem <strong>{template?.name}</strong>?
        </p>
        <p className="text-danger mb-0">
          <strong>Atenção:</strong> Esta ação não pode ser desfeita.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="falcon-default" onClick={handleClose}>
          Cancelar
        </Button>
        <Button variant="danger" onClick={handleConfirm}>
          Excluir
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default MessageTemplateDeleteModal;

